import { useState,useEffect } from "react";

import "./App.css";
import { ToastContainer, toast } from "react-toastify";

import ViewClient from "./components/Client/ViewClient";

import Sidebar from "./components/Layout/Sidebar/Sidebar";
import ContentTop from "./components/Layout/ContentTop/ContentTop";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard";
import CompanyList from "./components/Client/CompanyList";
import Login from "./components/Login/Login";
import SidebarMobile from "./components/Layout/Sidebar/SidebarMobile";
function App() {
  const [token, setToken] = useState();

  const handleLogOut = () => {
    window.localStorage.removeItem("LICENSE_TOKEN");
    window.localStorage.removeItem("user");
    localStorage.clear();
    setToken(false);
  };
  useEffect(() => {
    const _token = window.localStorage.getItem("LICENSE_TOKEN");
   
    
    if (_token === undefined || _token === null) {
      setToken(false);
      
      handleLogOut();
    } else {
      setToken(_token);
 
    }
  }, [token]);
  const save_token = (e) => {
    console.log(e)
    window.localStorage.setItem("LICENSE_TOKEN", e);
    setToken(e);
  };
  if (token === false) {
    return (
      <div>
        <ToastContainer />
        <Login
          setToken={save_token}

 
        ></Login>
      </div>
    );
  }



  return (
    <div className="App">
       <ToastContainer />
      <div>
        <Sidebar />
      </div>
     
      <div className="rounded main-content">
        <ContentTop />
       
        <div className="main-container">
          <Routes>
          <Route
                  path="/"
                  element={
                    <Login setToken={save_token} exact={true} />
                  }
                />

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/company" element={<CompanyList />} />

            <Route path="/viewClient" element={<ViewClient />} />
          </Routes>
        </div>
      </div>
      <div className="side">
            <SidebarMobile />
          </div>
    </div>
  );
}

export default App;
